//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { IUrlRouterProvider } from 'angular-ui-router';
import stubTrue from 'lodash/fp/stubTrue';

import {
  IPartialState,
  NavGroup,
  StateFactory,
  componentNameToTemplate,
  hasFeature,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

// Sets default values for state data
function TwitterStateFactory(state: IPartialState) {
  const accessFn = state.data?.hasAccess || stubTrue;
  const data = {
    title: 'Twitter',
    navGroup: NavGroup.PUBLISHING,
    ...state.data,
    hasAccess: () => hasFeature(FeatureNames.SocialDashboards) && accessFn(),
  };
  return StateFactory({
    ...state,
    data,
  });
}

export function routingRules(urlRouterProvider: IUrlRouterProvider) {
  urlRouterProvider.when('/twitter', '/twitter-v2');
  urlRouterProvider.when('/twitter/schedule', '/twitter-v2/schedule');
  urlRouterProvider.when(
    '/twitter/schedule/timeline',
    '/twitter-v2/schedule/timeline',
  );
  urlRouterProvider.when(
    '/twitter/schedule/post-details?:scheduledPostId&:postTimeMs&:targetCuid',
    '/twitter-v2/schedule/post-details?:scheduledPostId&:postTimeMs&:targetCuid',
  );
  urlRouterProvider.when('/twitter', '/twitter/schedule');
  urlRouterProvider.when('/twitter/schedule', '/twitter/schedule/timeline');
  urlRouterProvider.when('/twitter/schedule/timeline', '/schedule/calendar');
  urlRouterProvider.when('/twitter-v2/schedule/timeline', '/schedule/calendar');
}

export const states = {
  twitter: TwitterStateFactory({
    url: '/twitter',
    template: componentNameToTemplate('twitterApp'),
    resolve: {
      ...lazyLoadModule('curalate.twitter', () => import('./TwitterApp')),
    },
  }),
};
